import { IApplicationContext } from 'shared/common/types/applicationContext';
import { ICianCard, ISaveCardFormResponse } from 'shared/createCard/types/cianCard';

interface IFetchCianCardParams {
  profile: ICianCard;
}

export async function fetchSaveCard(
  { httpApi }: IApplicationContext,
  { profile }: IFetchCianCardParams,
): Promise<ISaveCardFormResponse> {
  const { response } = await httpApi.fetch({
    apiType: 'external',
    microserviceName: 'info-api',
    assertStatusCodes: [200],
    requestContentType: 'json',
    pathApi: '/api/card/v1/save-card',
    method: 'POST',
    parameters: { profile },
  });

  return response as ISaveCardFormResponse;
}
